export default __webpack_public_path__ + "static/media/d42631aa-c987-4c18-81bd-d29faf4abc9c - 017_ARNAB DAN.28fa0ba7.jpg";